export default __webpack_public_path__ + "static/Lato-Bold-89b618086a797a8be0f4549489bb2993.woff";